export default {
	base: "/api/v1",
};
